import React from "react";
import { FilterBar, Menu, SearchBar, Select } from "@sscs/ui";
import { normalizeActionName } from "../../../utils";
const Filter = ({ filter, actionTypes, eventTypes, onChange, }) => {
    var _a;
    return (React.createElement(FilterBar, { filters: [
            {
                id: "event-name",
                control: (React.createElement(SearchBar, { id: "event-name-search", value: (_a = filter.eventName) !== null && _a !== void 0 ? _a : "", onChange: (name) => onChange({ ...filter, eventName: name === "" ? null : name }), label: "Event name search", slotProps: { htmlInput: { maxLength: 256 } } })),
            },
            {
                id: "action-type",
                width: "250px",
                control: (React.createElement(Select, { label: "Filter by action type", id: "action-type-filter", labelId: "action-type-filter-label", displayEmpty: true, shrinkLabel: true, value: filter.doAction, onChange: (value) => onChange({ ...filter, doAction: value }) },
                    React.createElement(Menu.Item, { id: "show-all-action-types", value: "ALL" }, "Show all action types"),
                    actionTypes.map((actionType) => (React.createElement(Menu.Item, { key: `filter-by-${actionType}`, id: `filter-by-${actionType}`, value: actionType }, normalizeActionName(actionType)))))),
            },
            {
                id: "event-type",
                width: "250px",
                control: (React.createElement(Select, { label: "Filter by event type", id: "event-type-filter", labelId: "event-type-filter-label", displayEmpty: true, shrinkLabel: true, value: filter.onEvent, onChange: (value) => onChange({ ...filter, onEvent: value }) },
                    React.createElement(Menu.Item, { id: "show-all-event-types", value: "ALL" }, "Show all event types"),
                    eventTypes.map((eventType) => (React.createElement(Menu.Item, { key: `filter-by-${eventType}`, id: `filter-by-${eventType}`, value: eventType }, normalizeActionName(eventType)))))),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map